import { PbxHttpClient } from "@/services/httpclient";

const state = {
  answers: [],
};

const getters = {
  GET_ANSWERS: (state) => state.answers,
};

const mutations = {
  SET_ANSWERS: (state, payload) => (state.answers = payload),

  PUSH_ANSWER: (state, payload) => state.answers.push(payload),

  UPDATE_ANSWER: (state, payload) => {
    const index = state.answers.findIndex((el) => el.id === payload.id);
    state.answers.splice(index, 1, payload);
  },

  DELETE_ANSWER: (state, id) => {
    const index = state.answers.findIndex((el) => el.id === id);
    state.answers.splice(index, 1);
  },
};
const actions = {
  async REGISTER_ANSWER({ commit }, payload) {
    try {
      const response = await PbxHttpClient.post(`/quality/answer`, payload);
      commit("PUSH_ANSWER", response.data.answer);
      return;
    } catch (error) {
      return error.message.includes("422") ? 422 : error;
    }
  },

  async SHOW_ANSWERS({ commit }, idQuestion) {
    try {
      const response = await PbxHttpClient.get(
        `/quality/answer/index/${idQuestion}`
      );
      commit("SET_ANSWERS", response.data.data[0].answer);
      return;
    } catch (error) {
      // console.log("Este es el error", error)
      return Promise.reject(error);
    }
  },

  async EDIT_ANSWER({ commit }, { name, id, value, question_id }) {
    try {
      const payload = { name, value, question_id };
      const response = await PbxHttpClient.put(
        `/quality/answer/${id}`,
        payload
      );
      commit("UPDATE_ANSWER", response.data.answer);
    } catch (error) {
      return error.message.includes("422") ? 422 : error;
    }
  },

  async DELETE_ANSWER({ commit }, id) {
    try {
      const response = await PbxHttpClient.delete(`/quality/answer/${id}`);
      commit("DELETE_ANSWER", id);
      return;
    } catch (error) {
      return Promise.reject(error);
    }
  },
};

// Exportar Clientes
export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
